import CheckBox from '@components/std-components/CheckBox'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

export interface SelectAllElementProps {
  isSelected: boolean
  onSelect: () => void
  onDeselect: () => void
  disabled: boolean
  filterSubColumns?: boolean
  subTitle?: string
}

const SelectAllElement: FC<SelectAllElementProps> = ({
  isSelected,
  onDeselect,
  onSelect,
  disabled
}) => {
  const { t } = useTranslation()
  return (
    <CheckBox
      checked={isSelected}
      checkBoxClick={e => (isSelected ? onDeselect() : onSelect())}
      disabled={disabled}
      id='selectAll'
      name='selectAll'
      label={t('common.label.selectAll', 'Select all')}
      variant='checkboxlabel'
    />
  )
}

export default SelectAllElement
